import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default () => {
  const trackKeywordClickEvent = () => {
    useMatomoEvent({
      category: `${getCurrentView()} View`,
      action: "Click Keyword",
      name: "Keywords"
    });
  };

  return { trackKeywordClickEvent };
};
